import { CustomPopoverProps } from '@aibees/shared/components';
import { PopoverType } from '@aibees/shared/components/custom-popover/use-popover';
import { ParsedPreset } from '@aibees/shared/definition';
import { TransferListPresetValue } from '@aibees/shared/features';
import { UseBoolean } from '@aibees/shared/hooks';

export interface TableLayoutModifierDialogProps
  extends Omit<CustomPopoverProps, 'onSubmit' | 'onSelect'> {
  className?: string;
  dialogState: UseBoolean;
  managementPopoverState: PopoverType;
  transferListPopoverState: PopoverType;
}

export type TableLayoutTemplateItem = ParsedPreset<TableLayoutTemplate>;

export interface TableLayoutTemplate extends TransferListPresetValue {
  private?: boolean;
}

export enum TemplateTabs {
  ALL = 'ALL',
  MINE = 'MINE',
  SHARED = 'SHARED',
}
